const r={SPACE:" ",ESC:["Esc","Escape"],TAB:"Tab",RETURN:"Enter",LEFT:"ArrowLeft",UP:"ArrowUp",RIGHT:"ArrowRight",DOWN:"ArrowDown"};export{r as KEYS};
//# sourceMappingURL=constants.js.map
